import { Component, OnInit } from '@angular/core';
import { ApiService } from '@app/core/services/api/api.service';
import {
  DashboardContentOptionsBuilder,
  FrameOptionsBuilder,
} from '@app/services/quicksight-analytics/quicksight-analytics.service';
import { ShopService } from '@app/services/shops/shop.service';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { DashboardExperience } from 'amazon-quicksight-embedding-sdk';
import moment from 'moment';

import { Moment } from 'moment';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'new-analytics',
  templateUrl: './new-analytics.component.html',
  styleUrls: ['./new-analytics.component.scss'],
  standalone: false,
})
export class NewAnalyticsComponent implements OnInit {
  notFoundMsg: string | null = null;
  constructor(
    private apiService: ApiService,
    private shopService: ShopService,
  ) {
    this.loading = true;
  }

  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  loading: boolean;
  error: string;
  embeddedExperience: DashboardExperience;
  async ngOnInit(): Promise<void> {
    this.shopService.shop$
      .pipe(
        switchMap((shop) => {
          if (shop?.metadata?.pipelineEnabled === 'true') {
            return this.apiService.get('quicksight/dashboard-embedded-url').pipe(map((result) => ({ result, shop })));
          }
          return of({ result: null, shop });
        }),
      )
      .subscribe(
        ({ result, shop }) => {
          if (!shop) {
            return;
          }

          if (!result?.url) {
            this.loading = false;
            this.notFoundMsg = 'Cannot find your analytics url, try to reach our support';
            return;
          }
          this.initIframe(result.url, shop);
        },
        (err) => {
          console.error(`Failed to get quicksight url ${err}`);
        },
      );
  }

  async initIframe(url: string, shop: Shop) {
    const beginningOfDataCollection = moment('2023-08-17T15:30:00');
    const shopInstalledMoment = moment(shop.created);
    const yesterdayMoment = moment().subtract(1, 'days');

    if (shopInstalledMoment.isBefore(beginningOfDataCollection)) this.minDate = beginningOfDataCollection.toDate();
    else this.minDate = shopInstalledMoment.toDate();

    this.maxDate = yesterdayMoment.toDate();
    this.startDate = moment().subtract(8, 'days').toDate();
    this.endDate = this.maxDate;

    const embeddingContext = await createEmbeddingContext();

    const frameOptionsBuilder = new FrameOptionsBuilder(url, '#analytics-container').withOnChange(
      (changeEvent, metadata) => {
        if ((changeEvent.eventName = 'CONTENT_LOADED')) {
          this.loading = false;
          const iframe = document.getElementsByTagName('iframe')[0];
          if (iframe) {
            iframe.style.border = '1px solid #e5e5e5';
          }
        }
      },
    );

    const contentOptionsBuilder = new DashboardContentOptionsBuilder()
      .withParameter('DeliveryCountry', shop.address.countryCode)
      .withParameter('Currency', shop.metadata['currency'])
      .withParameter('startDate', moment(this.startDate).toString())
      .withParameter('endDate', moment(this.endDate).toString())
      .withParameter('startHistoricalDate', moment(this.minDate).subtract(60, 'days').toString());

    this.embeddedExperience = await embeddingContext.embedDashboard(
      frameOptionsBuilder.build(),
      contentOptionsBuilder.build(),
    );
  }

  setDateRangeValue(value: { start: Moment; end: Moment }) {
    const { start, end } = value;
    if (!start || !end) {
      return;
    }

    this.embeddedExperience.setParameters([
      {
        Name: 'startDate',
        Values: [start.toString()],
      },
      {
        Name: 'endDate',
        Values: [end.toString()],
      },
    ]);
  }
}
